// Static site-wide content for Flowgrid Plumbing
import {
  Flame,
  Wrench,
  Zap,
  ShowerHead,
  Search,
  Siren,
  ShieldCheck,
  Clock,
  BadgeCheck,
  PhoneCall,
  Award,
  Sparkles,
} from "lucide-react";

export const BRAND = {
  name: "Flowgrid Plumbing",
  phone: "0415 988 997",
  phoneTel: "tel:+61415988997",
  email: "info@flowgridplumbing.com.au",
  emailHref: "mailto:info@flowgridplumbing.com.au",
  abn: "ABN 57 132 447 010",
  license: "NSW Lic. #000000C",
  logoUrl: "/uploads/van.png",
  vanUrl: "/uploads/van.png",
  heroBgUrl:
    "https://static.prod-images.emergentagent.com/jobs/f860a2fd-9c0f-464c-a319-696d193a5719/images/4f42db7d5658f607cac94acfc7e6056738f4d4a503112f19003f6d60ddf271e5.png",
  pipesUrl:
    "https://static.prod-images.emergentagent.com/jobs/f860a2fd-9c0f-464c-a319-696d193a5719/images/5ff0bcafcf23b46cd9bf89d544d56c2205ab804c9454a73cd0f5222bb4b0a308.png",
  plumberUrl: "https://images.unsplash.com/photo-1676210134188-4c05dd172f89?auto=format&fit=crop&w=1400&q=80",
  bathroomUrl: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=1400&q=80",
  social: {
    instagram: "https://www.instagram.com/flowgridplumbing",
    facebook: "https://www.facebook.com/share/194dXNTEA5/",
  },
};

export const SERVICES = [
  {
    slug: "emergency-plumbing",
    title: "Emergency Plumbing",
    short: "24/7 rapid response across Western Sydney.",
    icon: Siren,
    accent: "bg-orange-500",
    description:
      "Burst pipes, overflowing toilets, no water — we mobilise around the clock. Average on-site arrival under 60 minutes across Sydney Metro and the Inner West.",
    bullets: [
      "Available 24 hours, 7 days a week",
      "Live dispatch across Sydney Metro",
      "Fully stocked vans, fixed on the spot",
      "Upfront pricing — no nasty surprises",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_flowered-emergency/artifacts/lsw74y57_IMG_7824.png",
  },
  {
    slug: "installing-appliances",
    title: "Installing Appliances",
    short: "Sinks, basins, dishwashers, toilets & commercial fit-outs.",
    icon: Wrench,
    accent: "bg-brand-blue",
    description:
      "From a single dishwasher hookup to a full commercial bathroom fit-out, our licensed plumbers install appliances properly — water supply connected, waste lines correctly trapped, and every join leak-tested before we leave.",
    bullets: [
      "Sinks, basins, taps & mixer installations",
      "Dishwashers, washing machines & ice-maker fridges",
      "Toilets, urinals & cistern installations",
      "Commercial bathroom fit-outs & multi-fixture jobs",
      "Water supply lines + correctly trapped waste connections",
      "Tested, certified and warranted workmanship",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_flowered-emergency/artifacts/8innmxdt_IMG_0756.jpeg",
  },
  {
    slug: "hot-water-systems",
    title: "Hot Water Systems",
    short: "Same-day repair, replace & install.",
    icon: ShowerHead,
    accent: "bg-orange-500",
    description:
      "Gas, electric, heat-pump or solar — we repair every major brand and install efficient new units same-day where possible.",
    bullets: [
      "Rheem, Rinnai, Bosch, Vulcan & more",
      "Continuous-flow gas specialists",
      "Heat pump & solar conversions",
      "Manufacturer warranty honoured",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_flowered-emergency/artifacts/9mwmhdnl_1d9dcdf7-5604-413f-9ec4-e76655f26c63.jpeg",
  },
  {
    slug: "leak-detection",
    title: "Leak Detection",
    short: "Pinpoint hidden leaks. No tear-down.",
    icon: Search,
    accent: "bg-slate-900",
    description:
      "Non-invasive acoustic and thermal-imaging leak detection saves your tiles, your slab and your water bill.",
    bullets: [
      "Acoustic & thermal imaging tech",
      "Slab leak & concealed pipe detection",
      "Insurance-ready written reports",
      "Repair on the spot once found",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_flowered-emergency/artifacts/xqmnk2vk_IMG_5934.png",
  },
  {
    slug: "gas-fitting",
    title: "Gas Fitting",
    short: "Licensed gas plumbers, certified work.",
    icon: Flame,
    accent: "bg-orange-500",
    description:
      "From new gas points to leak repairs and compliance certificates — fully licensed NSW gas work for homes and small commercial sites.",
    bullets: [
      "Gas leak detection & repair",
      "New gas line installation",
      "Cooktop, oven & BBQ connections",
      "Compliance certificates issued",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_flowered-emergency/artifacts/49lxx6iq_IMG_5932.png",
  },
  {
    slug: "jet-blasting",
    title: "Jet Blasting",
    short: "High-pressure drain cleaning that clears the toughest blockages.",
    icon: Zap,
    accent: "bg-brand-blue",
    description:
      "Industrial-grade high-pressure water jetters cut through grease, tree roots, scale and debris that other tools can't touch — leaving your pipes properly clean, not just cleared.",
    bullets: [
      "Up to 5,000 PSI commercial jet machines",
      "Cuts through tree roots, grease & scale",
      "Sewer, stormwater & internal drain lines",
      "Optional CCTV camera report before & after",
      "Safe on PVC, cast iron, copper and clay pipes",
      "Same-day bookings across Sydney",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_flowered-emergency/artifacts/g7kncqnc_IMG_5829.png",
  },
];

export const SUBURBS = [
  {
    slug: "bankstown",
    name: "Bankstown",
    blurb:
      "Bankstown homes and small commercial — fast 24/7 response, fully licensed plumbers and gas fitters.",
    distance: "South-West",
    coords: [-33.9181, 151.0353],
  },
  {
    slug: "strathfield",
    name: "Strathfield",
    blurb:
      "Strathfield, Homebush and Strathfield South — apartments, homes and commercial plumbing.",
    distance: "Inner West",
    coords: [-33.8800, 151.0900],
  },
  {
    slug: "burwood",
    name: "Burwood",
    blurb:
      "Burwood, Burwood Heights and Croydon — full-service plumbing for homes and small commercial.",
    distance: "Inner West",
    coords: [-33.8794, 151.1042],
  },
  {
    slug: "lakemba",
    name: "Lakemba",
    blurb:
      "Lakemba, Wiley Park and Belmore — same-day bookings and 24/7 emergency plumbing.",
    distance: "South-West",
    coords: [-33.9214, 151.0775],
  },
  {
    slug: "punchbowl",
    name: "Punchbowl",
    blurb:
      "Punchbowl and Roselands — gas fitting, hot water and renovation specialists.",
    distance: "South-West",
    coords: [-33.9275, 151.0533],
  },
  {
    slug: "chester-hill",
    name: "Chester Hill",
    blurb:
      "Chester Hill, Bass Hill and Villawood — every plumbing job handled by one local crew.",
    distance: "South-West",
    coords: [-33.8783, 151.0061],
  },
  {
    slug: "bass-hill",
    name: "Bass Hill",
    blurb:
      "Bass Hill and Lansdowne — gas, hot water and bathroom renos.",
    distance: "South-West",
    coords: [-33.9072, 150.9994],
  },
  {
    slug: "villawood",
    name: "Villawood",
    blurb:
      "Villawood and Carramar — local crew, upfront fixed pricing.",
    distance: "South-West",
    coords: [-33.8744, 151.0028],
  },
  {
    slug: "parramatta",
    name: "Parramatta",
    blurb:
      "From Harris Park to North Parramatta — apartment, terrace and commercial plumbing handled.",
    distance: "Western Sydney",
    coords: [-33.8136, 151.0034],
  },
  {
    slug: "auburn",
    name: "Auburn",
    blurb:
      "Auburn, Lidcombe and Berala — emergency plumbing, hot water and gas fitting.",
    distance: "Western Sydney",
    coords: [-33.8497, 151.0331],
  },
  {
    slug: "lidcombe",
    name: "Lidcombe",
    blurb:
      "Lidcombe and Rookwood — every plumbing service, one trusted crew.",
    distance: "Western Sydney",
    coords: [-33.8633, 151.0411],
  },
  {
    slug: "homebush",
    name: "Homebush",
    blurb:
      "Homebush and Flemington — apartments, terraces and commercial sites.",
    distance: "Inner West",
    coords: [-33.8636, 151.0822],
  },
  {
    slug: "concord",
    name: "Concord",
    blurb:
      "Concord and Mortlake — heritage homes, kitchens and bathroom renos.",
    distance: "Inner West",
    coords: [-33.8639, 151.1014],
  },
  {
    slug: "five-dock",
    name: "Five Dock",
    blurb:
      "Five Dock, Drummoyne and Russell Lea — full-service plumbing & gas.",
    distance: "Inner West",
    coords: [-33.8694, 151.1297],
  },
  {
    slug: "ashfield",
    name: "Ashfield",
    blurb:
      "Ashfield, Summer Hill and Croydon — Inner West specialists.",
    distance: "Inner West",
    coords: [-33.8881, 151.1255],
  },
  {
    slug: "leichhardt",
    name: "Leichhardt",
    blurb:
      "Leichhardt, Annandale and Lilyfield — same-day bookings.",
    distance: "Inner West",
    coords: [-33.8836, 151.1542],
  },
  {
    slug: "hurstville",
    name: "Hurstville",
    blurb:
      "Hurstville and Kogarah — apartments, units and commercial sites covered.",
    distance: "South",
    coords: [-33.9678, 151.1003],
  },
  {
    slug: "liverpool",
    name: "Liverpool",
    blurb:
      "Covering Liverpool, Casula and Moorebank — gas, hot water and renovations.",
    distance: "South-West",
    coords: [-33.9200, 150.9300],
  },
  {
    slug: "penrith",
    name: "Penrith",
    blurb:
      "Penrith, Kingswood and Cambridge Park — hot water, drains, gas.",
    distance: "Western Sydney",
    coords: [-33.7506, 150.6943],
  },
  {
    slug: "mount-druitt",
    name: "Mount Druitt",
    blurb:
      "Mount Druitt, Whalan and Tregear — 24/7 emergency plumbing.",
    distance: "Western Sydney",
    coords: [-33.7700, 150.8233],
  },
  {
    slug: "campbelltown",
    name: "Campbelltown",
    blurb:
      "Campbelltown and Macarthur — homes serviced 7 days.",
    distance: "Outer South-West",
    coords: [-34.0667, 150.8164],
  },
  {
    slug: "sydney-cbd",
    name: "Sydney CBD",
    blurb:
      "Sydney CBD apartments, terraces and commercial sites — fast city response.",
    distance: "City",
    coords: [-33.8688, 151.2093],
  },
];

export const TRUST_BADGES = [
  { icon: ShieldCheck, label: "Licensed & Insured" },
  { icon: Clock, label: "24/7 Emergency" },
  { icon: BadgeCheck, label: "Upfront Pricing" },
  { icon: Award, label: "5-Star Rated" },
  { icon: Sparkles, label: "Same-Day Service" },
  { icon: PhoneCall, label: "Free Phone Quotes" },
];

export const TESTIMONIALS = [
  {
    name: "Aisha R.",
    suburb: "Newtown",
    quote:
      "Burst pipe at 11pm — Flowgrid had a plumber in our driveway in 35 minutes. Calm, professional, fixed it cleanly. Lifesavers.",
    rating: 5,
  },
  {
    name: "Daniel M.",
    suburb: "Balmain",
    quote:
      "Replaced our ancient hot water system the same day I called. Fair price, no upsell, and they cleaned up after. Highly recommend.",
    rating: 5,
  },
  {
    name: "Priya S.",
    suburb: "Marrickville",
    quote:
      "Used the CCTV drain camera and showed me exactly what the issue was. Honest crew — I won't call anyone else.",
    rating: 5,
  },
  {
    name: "Jack T.",
    suburb: "Leichhardt",
    quote:
      "Sorted a tricky gas oven install that two other plumbers walked away from. Knowledgeable and tidy.",
    rating: 5,
  },
  {
    name: "Mel K.",
    suburb: "Glebe",
    quote:
      "Quoted upfront, arrived on time, fixed the leak in our slab. Insurance loved their written report.",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "Do you really answer the phone at 2am?",
    a: "Yes. Flowgrid runs a true 24/7 emergency line — a real plumber, not a call centre. Burst pipes, sewer overflows, gas leaks: we dispatch immediately.",
  },
  {
    q: "How much does a plumber cost in Western Sydney?",
    a: "We provide free phone quotes and an upfront fixed price on-site before any work begins. No call-out fees on jobs we complete on the day.",
  },
  {
    q: "Which suburbs do you cover?",
    a: "All of Western and Outer Western Sydney including Blacktown, Penrith, Parramatta, Mount Druitt, St Marys, Liverpool, Campbelltown and every suburb in between.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes. Flowgrid Plumbing holds a full NSW Plumbing & Gas Fitting licence and carries $20 million in public liability insurance. Certificates available on request.",
  },
  {
    q: "Do you offer warranties on your work?",
    a: "Every job is backed by our workmanship warranty, and all parts carry full manufacturer warranties which we honour for you.",
  },
  {
    q: "Can you provide a report for my insurance claim?",
    a: "Absolutely. Our leak detection and CCTV drain jobs come with a detailed written report and imagery — accepted by all major insurers.",
  },
];
